import { render, staticRenderFns } from "./CurrentLevelSelection.vue?vue&type=template&id=7b10b816&"
import script from "./CurrentLevelSelection.vue?vue&type=script&lang=js&"
export * from "./CurrentLevelSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports